import type { EcosystemProfileSetting } from '@frontend/types';

async function authJson<T>(path: string, token: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init?.headers || {}),
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error((data as { message?: string }).message || `Request failed: ${response.status}`);
  }
  return data as T;
}

export async function fetchProfileEcosystems(token: string): Promise<EcosystemProfileSetting[]> {
  const data = await authJson<{ ecosystems?: EcosystemProfileSetting[] }>(
    '/api/profile/ecosystems',
    token,
  );
  return data.ecosystems || [];
}

export async function updateProfileEcosystem(
  ecosystemId: string,
  token: string,
  body: Partial<EcosystemProfileSetting>,
): Promise<EcosystemProfileSetting> {
  return authJson<EcosystemProfileSetting>(`/api/profile/ecosystems/${ecosystemId}`, token, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}
